export const GUARDIAN_SERVICE_ID_INVISIBLE = "INVISIBLE_GUARDIAN";
export const REFERRAL_CODE_STORAGE_KEY = "giants.referral";
export const REFERRAL_CODE_VALID_DAYS = 5;
export const GAS_LIMIT_MODIFIER = process.env.NEXT_PUBLIC_GAS_LIMIT_MODIFIER ? parseFloat(process.env.NEXT_PUBLIC_GAS_LIMIT_MODIFIER) : 1.1;
export const MEAN_VC_MULTIPLIER = 1.15;
export const MAX_UPGRADING_BUILDINGS_MULTIPLIER = 0.66;
export const TOTAL_LEADERBOARD_PRIZES_AMOUNT = 130416;
export const MAX_REFERRAL_HIERACHY_LEVEL = 3;